export default "__VITE_ASSET__Bz2b_9OJ__"